import clsx from "clsx";
import { forwardRef } from 'react';
import Cta from '@/components/cta/cta';
import Minus from '@/components/icon/minus';
import Plus from '@/components/icon/plus';


const ZoomControls = forwardRef(function ZoomControls(
  { onZoomIn, onZoomOut, zoomLevel, minZoom = 1, maxZoom = 3, isDark = false, className },
  ref
) {
  const canZoomOut = zoomLevel > minZoom;
  const canZoomIn = zoomLevel < maxZoom;
  const ctaClassName = clsx(
    "cta-icon-plus-minus cta-icon-stroke-theme",
    isDark
      ? "cta-dark disabled:bg-main-dark/30"
      : "cta-light disabled:bg-main-light/30",
  );

  return (
    <div
      ref={ref}
      className={clsx('flex gap-x-1.5', className)}
      role="group"
      aria-label="Zoom controls"
    >
      <Cta
        className={ctaClassName}
        aria-label="Zoom out"
        onClick={onZoomOut}
        disabled={!canZoomOut}
      >
        <Minus aria-hidden="true" />
      </Cta>

      <Cta
        className={ctaClassName}
        aria-label="Zoom in"
        onClick={onZoomIn}
        disabled={!canZoomIn}
      >
        <Plus className="!w-4" aria-hidden="true" />
      </Cta>
    </div>
  );
});

export default ZoomControls;
